import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import StyleWrapper from "./style";
import fulLogo from "../../../../assets/images/logos/Tawuniya-Logo.svg";
import { useSelector, useDispatch } from "react-redux";
import { Toast } from "primereact/toast";
import lead_percentage_ico from "../../../../assets/images/lead/discount.svg";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import * as actions from "redux/actions/motorActions";
import { updateLoading } from "redux/actions/commonActions";
import { getPromotionDetails, getCustomerDetails } from "../../services/index";
import { ProgressBar } from "primereact/progressbar";
import loaderLogo from "assets/images/icons/logo.svg";
import { toGregorian } from "hijri-converter";
import moment from "moment";
import { isSaudi } from "helpers/utils";
import LanguageSwitcherMobile from "_shared/LanguageSwitcherMobile";
import {
  setJWT,
  setRequestId
} from "redux/actions/commonActions";

const LeadGeneration = (props) => {
 const toast = useRef(null);
 const { t, i18n } = useTranslation();
 const location = useLocation();
 const dispatch = useDispatch();
 const navigate = useNavigate();

 const loading = useSelector((state) => state.common.isLoading);
 const [cDetails, setCDetails] = useState(null);
 const [tmx, setTmx] = useState(null);

 useEffect(() => {
  i18n.changeLanguage('ar');
  const params = new URLSearchParams(location.search);
  let tmxParam = params.get("tmx");
  if(!tmxParam) {
   tmxParam = window.location.search.slice(5)
  }
  if (tmxParam) {
   setTmx(tmxParam);
   dispatch(updateLoading(true));
   dispatch(actions.setTmx(tmxParam));
  }
  dispatch(actions.LeadGeneratation(true))
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: "Motor_ELM_Lead_landing",
   "item_name": "Motor Individual",
   "item_category": "Motor Individual ELM",
   "item_class": "Individual",
   "funnel_step": "step_0",
   "step_name": "ELM Lead Landing",
   "page_source": "internal_click" //calculated based on using document.referrer
  });
  getLeadDetails(tmxParam);
 }, []);

 const handleLeadBtnClick = async () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: "Motor_ELM_Lead_Begin",
   "item_name": "Motor Individual",
   "item_category": "Motor Individual ELM",
   "item_class": "Individual",
   "funnel_step": "step_1",
   "step_name": "ELM Lead Begin",
   "TMX" : tmx,
  });
  try {
   dispatch(updateLoading(true));
   const res = cDetails;
   let dateData=res.customerDetails?.dateOfBirth;
   let yob = moment(dateData).format("YYYY");
   const mob = moment(dateData).format("MM");

   // Hijri date Fix
   let convertedDate = null;
   if (res && isSaudi(res.customerDetails.idNumber)) {
    const birthDateList = res.customerDetails?.dateOfBirth.split("-");
    if (+birthDateList[0] < 1800) {
        convertedDate = toGregorian(+birthDateList[0], +birthDateList[1], +birthDateList[2]);
    }
   }
   //_________________
 
   if (res && res.customerDetails) {
    const getCustDtlsReq = {
     nationalId: res.customerDetails.idNumber,
     yob: convertedDate?.gy.toString() || yob.toString(),
     mob: convertedDate?.gm.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      }).toString() || mob.toString(),
    };
    const customerDetails = await getCustomerDetails(getCustDtlsReq, 'elm');
    dispatch(updateLoading(false));
    dispatch(
        actions.updateCustomerDetails({
         personalDetails: { ...getCustDtlsReq },
         customerDetails: customerDetails,
        })
    );
    dispatch(actions.setTmxVehicleDetails(res));
    navigate("/lead/vehicle-details", { state: { lead: true ,tmx:tmx} });
   } else {
    dispatch(updateLoading(false));
    toast.current.show({
     severity: "error",
     summary: "Failed to get Promotion details",
     detail: res?.resultMessage,
     life: 7000,
    });
   }
  } catch (error) {
   dispatch(updateLoading(false));
   toast.current.show({
    severity: "error",
    summary: "Failure",
    detail: "Something went wrong. Try again!",
    life: 7000,
   });
  }
 };

 const getLeadDetails = (tmxParam) =>{
  const reqData = {
    tmx: tmxParam || tmx,
    languageCode: i18n.resolvedLanguage === "ar" ? "A" : "E",
    channelDetails: {
     applicationCategory: "RH",
     branchCode: "85",
     sourceCode: "550541",
     applicationType: "RHSP",
     userName: "EBUSUSER",
     channelCode: "85",
    },
   };
   getPromotionDetails(reqData).then(res => {
      if (res.resultCode === "F") {
        navigate("/motor");
      } else {
        setCDetails(res)
        const Authtoken = res.authToken
        const Requestid = res.requestId
        dispatch(setJWT(Authtoken))
        dispatch(setRequestId(Requestid))
        dispatch(updateLoading(false));
      }
   })
   .catch( e => {
    navigate("/motor");
   })
   .finally(() => {})
 }



 return (
   <StyleWrapper className={i18n.language === "ar" ? "ar" : ""}>
     {loading && (
       <>
         <div className="loader-overlay">
           <img src={loaderLogo} alt="" />
         </div>
         <ProgressBar mode="indeterminate" color="#6B47F5" style={{ height: "6px" }}></ProgressBar>
       </>
     )}
     <div className="header">
       <img className="success-header-left-logo d-block" src={fulLogo} alt="logo" />
       <LanguageSwitcherMobile />
     </div>
     <div className="container">
       <div className="card_wrapper">
         <div className="card">
           <div className="card_content">
             <div className="lead_text order-last order-md-first">
               <h1>{t("LEAD.HELLO")} {i18n.language === 'ar'? cDetails?.customerDetails?.nameAr : cDetails?.customerDetails?.nameEn} !</h1>
               <h4>
                 {/* <strong> {t("LEAD.Congratulations")}!</strong> */}
                  {t("LEAD.TEXT1")}
               </h4>
               <p>{t("LEAD.TEXT2")}</p>
             </div>
             <div className="lead_image">
               <img
                 className="success-mid-image"
                 src={lead_percentage_ico}
                 alt="policySuccess"
                 width={290}
                 height={300}
               />
             </div>
           </div>
         </div>
       </div>
     </div>
     <div className="footer">
       <Button onClick={handleLeadBtnClick} className="act-btn" disabled={!cDetails}>
         {t("LEAD.Button")}
       </Button>
     </div>
     <Toast ref={toast} />
   </StyleWrapper>
 );
};

export default LeadGeneration;
